import React from "react";
import styled from "styled-components";
import { Container, Row, Col } from "react-bootstrap";

const SectionStyled = styled.section`
  padding: 96px 0 48px;
  background: var(--nd-black);
`;

const SectionLabel = styled.p`
  font-family: 'Space Mono', monospace;
  font-size: 11px;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--nd-text-secondary);
  margin-bottom: 16px;
`;

const SectionTitle = styled.h2`
  font-family: 'Space Grotesk', sans-serif;
  font-size: 36px;
  font-weight: 500;
  color: var(--nd-text-display);
  letter-spacing: -0.02em;
  line-height: 1.1;
  margin-bottom: 48px;
`;

const ServiceCard = styled.div`
  background: var(--nd-surface);
  border: 1px solid var(--nd-border);
  border-radius: 12px;
  padding: 24px;
  margin-bottom: 24px;
  height: 100%;
  transition: border-color 250ms cubic-bezier(0.25, 0.1, 0.25, 1);

  &:hover { border-color: var(--nd-border-visible); }
`;

const ServiceTitle = styled.h3`
  font-family: 'Space Grotesk', sans-serif;
  font-size: 18px;
  font-weight: 500;
  color: var(--nd-text-display);
  margin-bottom: 8px;
  line-height: 1.3;
`;

const ServiceDesc = styled.p`
  font-family: 'Space Grotesk', sans-serif;
  font-size: 14px;
  color: var(--nd-text-secondary);
  line-height: 1.5;
  margin: 0;
`;

const services = [
  { title: "Cloud Infrastructure", description: "Infrastructure that doesn't page you at 3 AM. Multi-region, auto-scaling, failover. The boring stuff, done right." },
  { title: "CI/CD & Automation", description: "Push code, it deploys. Automatically tested, automatically rolled back if something breaks. We set it up, you stop thinking about it." },
  { title: "Kubernetes & Containers", description: "Containers without the PhD. Cluster setup, Helm charts, scaling policies. We make Kubernetes feel like it's not trying to kill you." },
  { title: "Observability", description: "Know what's broken before your users do. Dashboards, alerts, and the discipline to not alert on everything." },
  { title: "Cost Optimization", description: "Stop paying for things you're not using. We've saved clients $500K+ total. Usually starts with 'why do you have 14 idle load balancers?'" },
  { title: "Security & Compliance", description: "The stuff you know you should do but haven't. IAM reviews, secrets rotation, network policies. We won't make it fun, but we'll make it done." },
];

const Services = () => {
  return (
    <SectionStyled id="services">
      <Container>
        <SectionLabel>WHAT WE'RE GOOD AT</SectionLabel>
        <SectionTitle>Six things we've done enough to be dangerous</SectionTitle>
        <Row>
          {services.map((service, index) => (
            <Col md="6" lg="4" key={index}>
              <ServiceCard>
                <ServiceTitle>{service.title}</ServiceTitle>
                <ServiceDesc>{service.description}</ServiceDesc>
              </ServiceCard>
            </Col>
          ))}
        </Row>
      </Container>
    </SectionStyled>
  );
};

export default Services;
